jQuery(function($) {
    'use strict';

    var AppServices = function() {
    }

    AppServices.prototype.init = function() {
        $(document).on('click', '.btn-service', function() {
            var buttons = $(this).closest('.services-wrapper').find('.services-buttons-wrapper').find('.btn-service');
            var slideshow = $('.slideshow-services');

            var int = $(this).data('serviceInt');

            slideshow.slick('goTo', int - 1);

            buttons.removeClass('btn-primary').addClass('btn-outline-primary');
            $(this).removeClass('btn-outline-primary').addClass('btn-primary');

            // Prüfe, ob der Bildschirm schmal ist (z. B. <= 768px, typisch für Mobilgeräte)
            if ($(window).width() <= 768) {
                // Berechne die Scroll-Position mit einem Offset von 50px
                const scrollPosition = $('.slideshow-services').offset().top - 100;
                // Springe zur gewünschten Div mit sanftem Scrollen
                $('html, body').animate({
                    scrollTop: scrollPosition
                }, 500); // 500ms für sanftes Scrollen
            }
        });
    }

    $.AppServices = new AppServices;
    $.AppServices.Constructor = AppServices;
});

jQuery(function($) {
    'use strict';

    $.AppServices.init();
});



